module.exports = __webpack_public_path__ + "img/ertiga-xl7.3d34a83c.svg";